import { PublicClientApplication } from '@azure/msal-browser';

let msalInstance: PublicClientApplication | null = null;


export const setMsalInstance = (instance: PublicClientApplication) => {
  msalInstance = instance;
};


export const getMsalInstance = (): PublicClientApplication => {
  if (!msalInstance) {
    throw new Error("MSAL instance has not been initialized. Call 'setMsalInstance' first.");
  }
  return msalInstance;
};